export const getEditor = (id: string) => {
	return document.querySelector(`#editor-${id} > .tiptap`);
};

export const applyOwnership = (id: string) => {
	const el = getEditor(id);
	el?.setAttribute('aria-owns', `selector-${id}`);
};

export const removeOwnership = (id: string) => {
	removeActiveElement(id);
	const el = getEditor(id);
	el?.removeAttribute('aria-owns');
};

export const setActiveElement = (id: string, index: number) => {
	const el = getEditor(id);

	el?.setAttribute('aria-activedescendant', `options-${id}-${index}`);
};

export const removeActiveElement = (id: string) => {
	const el = getEditor(id);
	el?.removeAttribute('aria-activedescendant');
};
